import { render, staticRenderFns } from "./VersionSelectDropdown.vue?vue&type=template&id=479cb3f2&"
import script from "./VersionSelectDropdown.ts?vue&type=script&lang=ts&"
export * from "./VersionSelectDropdown.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VersionSelectDropdown.vue"
export default component.exports